<template>
  <b-list-group-item style="padding-top: 2px;padding-bottom: 2px;">
    <b-row no-gutters>
      <b-col md="1" sm="3">
        {{this.initialValue.nomUsuari}}
      </b-col>
      <b-col md="4" sm="10">
        <b-form-tags class="tags-rols" input-id="tags-rols-id" no-remove tag-pills v-model="this.initialValue.rols"/>
      </b-col>
      <b-col md="2" sm="6">
        {{ this.initialValue.dataCreacio!=null?this.initialValue.dataCreacio:'' }}
      </b-col>
      <b-col md="2" sm="6">
        {{ this.initialValue.dataBaixa!=null?this.initialValue.dataBaixa:'' }}
      </b-col>
      <b-col md="1" sm="3">
        {{this.initialValue.entitat.nom}}
      </b-col>
      <b-col md="2" sm="3" class="btn-group-usuari">
        <b-button-group size="sm" class="mr-2">
          <b-button size="sm" :disabled="esUsuariBaixa" variant="outline-primary" @click="onEditarUsuari()">
            <b-icon icon="pencil" aria-label="Editar"></b-icon>
          </b-button>
          <b-button size="sm" :disabled="disableDeleteUser || esUsuariBaixa" variant="outline-primary">
            <b-icon icon="person-dash" aria-label="Baixa" @click="onDonarBaixaUsuari()"></b-icon>
          </b-button>
          <b-button size="sm" :disabled="disableDeleteUser" variant="outline-primary" @click="onEliminarUsuari()">
            <b-icon icon="trash" aria-label="Eliminar"></b-icon>
          </b-button>
        </b-button-group>
      </b-col>
    </b-row>
    <b-alert :show="dismissCountDown" fade dismissible variant="danger" @dismissed="dismissCountDown=0" @dismiss-count-down="countDownChanged">
      Aquest usuari no es pot eliminar perquè té accions auditades. {{ dismissCountDown }}
    </b-alert>
  </b-list-group-item>

</template>

<script>
import usuariAplicacioService from "@/services/UsuariAplicacioService";
import auditAccesService from "@/services/AuditAccesService";

export default {
  name: "ItemUsuari",
  components: {
  },
  props: {
    initialValue:{
      type: Object,
      required: true
    }
  },
  data() {
    return {
      usuariLoguejat: null,
      messageAlert: false,
      dismissSecs: 5,
      dismissCountDown: 0
    };
  },
  computed:{
    disableDeleteUser(){
      return this.usuariLoguejat != null ? this.initialValue.idUsuari===this.usuariLoguejat.idUsuari : false;
    },
    esUsuariBaixa(){
      return this.initialValue.dataBaixa == null ? false : true;
    }
  },
  methods: {
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert() {
      console.log("showAlert")
      this.dismissCountDown = this.dismissSecs
    },
    async getUsuariLoguejat(){
      const response = await usuariAplicacioService.getUsuariLoguejatuari();
      this.usuariLoguejat = response.data;
    },
    onEditarUsuari(){
      this.$emit('editar-usuari', this.initialValue);
    },
    async onEliminarUsuari(){
      const response = await auditAccesService.existUsuariAuditat(this.initialValue.idUsuari);

      if(response.data){
        console.log("MUESTRA LA ALERTA");
        console.log(response);
        this.dismissCountDown = this.dismissSecs
      }else{
        console.log("SE PROCEDE A ELIMINAR");
        this.$emit('eliminar-usuari', this.initialValue);
      }
    },
    onDonarBaixaUsuari() {
      console.log(this.initialValue.idUsuari);
      this.$emit('usuari-baixa', this.initialValue)
    }
  },
  mounted() {
  },
  created() {
    this.getUsuariLoguejat();
    // console.log("getUsuariLoguejat");
    // console.log(this.usuariLoguejat);
  }
};
</script>

<style>
.label-usuari{
  font-weight: 500;
  font-size: 14px;
}
.btn-group-usuari{
  text-align: right;
}
.btn.disabled{
  color: #5f5f69;
}
.tags-rols li:last-child{
  display: none;
}
.tags-rols{
  background-color: white;
  border: 1px solid white;
}
.tags-rols button.close {
  display: none;
}

</style>